import { paginationFields } from '@/models/pagination.model';
import { showApiErrors } from '@/utils';
import { createSlice, isPending, isRejected } from '@reduxjs/toolkit';
import pick from 'lodash/pick';
import { getBrands, uploadBrandDetails } from './actionCreators';
import { BrandsState, SLICE_NAME, initialState } from './models';

export const brandsSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getBrands.fulfilled, (state: BrandsState, action) => {
        const { payload } = action;
        state.isLoading = false;
        state.brands = payload.brands;
        state.pagination = pick(payload, paginationFields);
      })
      .addCase(uploadBrandDetails.fulfilled, (state: BrandsState, action) => {
        state.isLoading = false;
        state.brands = (state.brands ?? []).map((item) => (item.id === action.payload.id ? action.payload : item));
      })
      .addMatcher(isPending(getBrands, uploadBrandDetails), (state: BrandsState) => {
        state.isLoading = true;
        state.error = null;
      })
      .addMatcher(isRejected(getBrands, uploadBrandDetails), (state: BrandsState, action) => {
        const { error } = action;
        state.isLoading = false;
        state.error = error;
        showApiErrors(error);
      });
  },
});
